import * as React from 'react';
import { createRoot } from 'react-dom/client';

import './Printable.scss';

/**
 * @deprecated
 * should be migrated to use react-hooks
 */
export class Printable {
  wrapped: React.JSX.Element;
  printContainer: HTMLDivElement | undefined;

  constructor(wrappedComponent: React.JSX.Element) {
    this.wrapped = wrappedComponent;
  }

  print() {
    this.unmount();
    this.mount();
  }

  readyToPrint = () => {
    window.print();
    this.unmount();
  };

  mount() {
    this.printContainer = document.createElement('div');
    this.printContainer.className = 'printable';
    document.body.appendChild(this.printContainer);

    const el = React.cloneElement(this.wrapped, { readyToPrint: this.readyToPrint });
    const root = createRoot(this.printContainer);
    root.render(el);
  }

  unmount() {
    if (this.printContainer) {
      const root = createRoot(this.printContainer);
      root.unmount();
      document.body.removeChild(this.printContainer);
      this.printContainer = undefined;
    }
  }
}
